import { API_BASE } from '../config/api';

async function safeJson(res) {
  const text = await res.text();
  try {
    return text ? JSON.parse(text) : null;
  } catch {
    return null;
  }
}

export async function fetchMedia(params = {}) {
  const usp = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === '') return;
    usp.set(k, String(v));
  });
  const qs = usp.toString();
  const res = await fetch(`${API_BASE}/media${qs ? `?${qs}` : ''}`);
  if (!res.ok) throw new Error((await safeJson(res))?.error || 'Failed to load media');
  return await safeJson(res);
}

export async function fetchMediaItem(id) {
  const res = await fetch(`${API_BASE}/media/${id}`);
  if (!res.ok) throw new Error((await safeJson(res))?.error || 'Failed to load media item');
  return await safeJson(res);
}

export async function createMedia(formData) {
  const res = await fetch(`${API_BASE}/media`, { method: 'POST', body: formData });
  if (!res.ok) throw new Error((await safeJson(res))?.error || 'Failed to create media');
  return await safeJson(res);
}

export async function updateMedia(id, formData) {
  formData.append('_method', 'PUT');
  const res = await fetch(`${API_BASE}/media/${id}`, { method: 'POST', body: formData });
  if (!res.ok) throw new Error((await safeJson(res))?.error || 'Failed to update media');
  return await safeJson(res);
}

export async function deleteMedia(id) {
  const res = await fetch(`${API_BASE}/media/${id}`, { method: 'DELETE' });
  if (!res.ok) throw new Error((await safeJson(res))?.error || 'Failed to delete media');
  return await safeJson(res);
}

